import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/43_sakura/43_sakura"
 * Contains 1 texture(s)
 */
export class Desktop43SakuraAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/43_sakura/43_sakura';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '43_sakura.jpg'
    ] as const;
}
